import { tierFromPlanKey } from './stripe-config'

export function selfHealingSessionLimit(plan: string | null | undefined): number {
  const tier = tierFromPlanKey(plan)
  if (['team', 'growth', 'enterprise', 'private-cloud', 'on-prem'].includes(tier)) return 10000
  return tier === 'individual' ? 20 : 5
}
